(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDrawer);
  } else {
    initDrawer();
  }

  function initDrawer() {
    window.drawer = {};
    let currentDrawer,
      isOpen = false;
    const drawerElements = {};

    function initializeDrawer(drawerElement) {
      if (!drawerElement.id)
        throw new Error('Missing id="" attribute on <drawer> element');
      const { id } = drawerElement;
      const direction = drawerElement.getAttribute("direction") || "left";
      const duration = +drawerElement.getAttribute("duration") || 400;
      const dimension = drawerElement.getAttribute("dimension") || "450px";
      const transform = /left|right/.test(direction)
        ? "translateX"
        : "translateY";
      const easing = drawerElement.getAttribute("easing") || "ease-in-out";
      const sign = /top|left/.test(direction) ? "-" : "";
      const transformValue = /right/.test(direction)
        ? `-${dimension}`
        : /top|left/.test(direction)
          ? dimension
          : "0";

      drawerElements[id] = {
        element: drawerElement,
        isOpen: false,
        direction: direction,
        open: {
          timing: { duration: duration, easing: easing },
          keyframes: { transform: `${transform}(0)` },
        },
        close: {
          timing: { duration: duration, easing: easing },
          keyframes: { transform: `${transform}(${sign}${dimension})` },
        },
      };

      drawerElement.style.setProperty(
        transform.endsWith("X") ? "width" : "height",
        dimension,
      );
      drawerElement.style.setProperty(
        "transform",
        drawerElements[id].close.keyframes.transform,
      );

      // Add event listeners for quantity changes and item removal
      drawerElement.addEventListener("click", handleQuantityChange);
      drawerElement.addEventListener("change", handleQuantityChange);
      drawerElement.addEventListener("click", handleItemRemoval);
    }

    function handleQuantityChange(event) {
      if (event.target.classList.contains("quantity-adjust") || event.target.classList.contains("quantity-input")) {
        const cartItem = event.target.closest(".grim-cart-item");
        const itemKey = cartItem.dataset.key;
        const quantityInput = cartItem.querySelector(".quantity-input");
        let newQuantity;

        if (event.target.classList.contains("quantity-adjust")) {
          const action = event.target.dataset.action;
          newQuantity = parseInt(quantityInput.value);

          if (action === "increase") {
            newQuantity++;
          } else if (action === "decrease") {
            newQuantity = Math.max(0, newQuantity - 1);
          }
          
          quantityInput.value = newQuantity;
        } else if (event.type === "change") {
          // Handle direct input changes
          newQuantity = Math.max(0, parseInt(event.target.value) || 0);
          event.target.value = newQuantity;
        } else {
          return; // Exit if it's not a change event or quantity adjust click
        }

        cartItem.classList.add("is-loading");
        updateCartItem(itemKey, newQuantity, cartItem);
      }
    }

    function handleItemRemoval(event) {
      if (event.target.classList.contains("remove-item")) {
        const itemKey = event.target.dataset.itemKey;
        const cartItem = event.target.closest(".grim-cart-item");
        cartItem.classList.add("is-loading");
        updateCartItem(itemKey, 0, cartItem);
      }
    }

    function updateCartItem(itemKey, newQuantity) {
      const drawer = document.querySelector('#grim-drawer');
      drawer.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQuantity
        })
      })
      .then(response => response.json())
      .then((data) => {
        return fetch(`${window.location.pathname}?sections=grim-drawer`);
      })
      .then(response => response.json())
      .then(sectionsData => {
        if (sectionsData && sectionsData["grim-drawer"]) {
          return updateDrawerContents(sectionsData["grim-drawer"]);
        }
        throw new Error("No drawer content in response");
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("cartItemUpdated", {
            detail: { itemKey, newQuantity }
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
        document.dispatchEvent(
          new CustomEvent("cartUpdateError", {
            detail: { itemKey, error }
          })
        );
      })
      .finally(() => {
        drawer.classList.remove('is-loading');
      });
    }

    // Add an event listener for the custom event
    document.addEventListener("cartItemUpdated", function (event) {
      const { itemKey, newQuantity } = event.detail;
      const item = document.querySelector(`.grim-cart-item[data-key="${itemKey}"]`);
      if (item) {
        item.classList.remove("is-loading");
        // You can add more update logic here if needed
      }
    });

    // Add an event listener for cart update errors
    document.addEventListener("cartUpdateError", function (event) {
      const { itemKey, error } = event.detail;
      const item = document.querySelector(`.grim-cart-item[data-key="${itemKey}"]`);
      if (item) {
        item.classList.remove("is-loading");
        // You can add error handling logic here
      }
      console.error("Cart update error:", error);
    });

    function updateDrawerContents(content) {
      return new Promise((resolve, reject) => {
        let newDrawerContent;
        if (typeof content === "string") {
          const parser = new DOMParser();
          const doc = parser.parseFromString(content, "text/html");
          newDrawerContent = doc.querySelector("#grim-drawer");
        } else if (typeof content === "object") {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = content;
          newDrawerContent = tempDiv.querySelector("#grim-drawer");
        }
        console.log(newDrawerContent);

        if (newDrawerContent) {
          const drawerElement = document.getElementById("grim-drawer");
          if (drawerElement) {
            // Update cart class based on contents
            if (newDrawerContent.querySelector(".cart__drawer-items").children.length > 0) {
              drawerElement.classList.remove("cart-empty");
              drawerElement.classList.add("cart-has-items");
            } else {
              drawerElement.classList.remove("cart-has-items");
              drawerElement.classList.add("cart-empty");
            }

            // Update both body and footer content
            const drawerBody = drawerElement.querySelector(".drawer-body");
            const drawerFooter = drawerElement.querySelector(".drawer-footer");
            const newBody = newDrawerContent.querySelector(".drawer-body");
            const newFooter = newDrawerContent.querySelector(".drawer-footer");

            if (drawerBody && newBody) {
              drawerBody.innerHTML = newBody.innerHTML;
            }
            
            if (drawerFooter && newFooter) {
              drawerFooter.innerHTML = newFooter.innerHTML;
            }

            resolve();
          } else {
            reject(new Error("Unable to find drawer element"));
          }
        } else {
          reject(new Error("Unable to find new drawer content in the response"));
        }
      });
    }

    function openDrawer(id, updateContent) {
      console.log(`Attempting to open drawer with id: ${id}`);
      if (id in drawerElements) {
        currentDrawer = drawerElements[id];
        console.log("Current drawer:", currentDrawer);
        if (currentDrawer && currentDrawer.element instanceof HTMLElement) {
          console.log("Opening drawer...");
          currentDrawer.element.classList.remove("is-closing");
          currentDrawer.element.classList.add("is-transition", "is-active");
          currentDrawer.element.style.setProperty(
            "transform",
            currentDrawer.open.keyframes.transform,
          );
          currentDrawer.element.setAttribute("aria-hidden", "false");
          currentDrawer.isOpen = isOpen = true;
          document.body.classList.add("drawer-open");
          showBackdrop();
          console.log("Drawer opened successfully");

          if (updateContent) {
            fetchAndUpdateDrawerContent();
          }
        } else {
          console.error("Drawer element is not a valid HTMLElement");
        }
      } else {
        console.error(`No drawer found with id: ${id}`);
      }
    }

    function fetchAndUpdateDrawerContent() {
      fetch(`${window.location.pathname}?sections=grim-drawer`)
        .then((response) => response.json())
        .then((sectionsData) => {
          if (sectionsData && sectionsData["grim-drawer"]) {
            updateDrawerContents(sectionsData["grim-drawer"]);
          } else {
            throw new Error("Unable to fetch updated drawer content");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    function closeDrawer(id) {
      if (id in drawerElements) {
        currentDrawer = drawerElements[id];
        if (currentDrawer && currentDrawer.element instanceof HTMLElement) {
          currentDrawer.element.classList.remove("is-active", "is-transition");
          currentDrawer.element.classList.add("is-closing");
          currentDrawer.element.setAttribute("aria-hidden", "true");
          currentDrawer.isOpen = isOpen = false;
          hideBackdrop();
          document.body.classList.remove("drawer-open");
          // Wait for the animation to complete before hiding the drawer
          currentDrawer.element.addEventListener(
            "animationend",
            function hideDrawer() {
              currentDrawer.element.style.setProperty(
                "transform",
                currentDrawer.close.keyframes.transform,
              );
              currentDrawer.element.classList.remove("is-closing");
              currentDrawer.element.removeEventListener(
                "animationend",
                hideDrawer,
              );
            },
            { once: true },
          );
        }
      }
    }

    function showBackdrop() {
      let backdrop = document.querySelector(".drawer-backdrop");
      if (!backdrop) {
        backdrop = document.createElement("div");
        backdrop.className = "drawer-backdrop";
      }
      
      // Always attach the click handler, whether the backdrop is new or existing
      backdrop.onclick = function() {
        if (currentDrawer) {
          closeDrawer(currentDrawer.element.id);
        }
      };
      
      if (!backdrop.parentElement) {
        document.body.appendChild(backdrop);
      }
      
      requestAnimationFrame(() => {
        backdrop.classList.add("is-active");
      });
    }

    function hideBackdrop() {
      const backdrop = document.querySelector(".drawer-backdrop");
      if (backdrop) {
        backdrop.classList.remove("is-active");
        backdrop.addEventListener("transitionend", function removeBackdrop() {
          backdrop.removeEventListener("transitionend", removeBackdrop);
          if (!isOpen) {
            backdrop.remove();
          }
        });
      }
    }

    document.addEventListener("click", function (event) {
      const toggleElement = event.target.closest(
        "[drawer-toggle], button[drawer-toggle]",
      );

      if (toggleElement && toggleElement.hasAttribute("drawer-toggle")) {
        console.log("drawer-toggle attribute found");
        const drawerID = toggleElement.getAttribute("drawer-toggle");
        console.log(`Drawer ID: ${drawerID}`);
        if (drawerElements[drawerID]) {
          console.log(
            `Drawer state: ${drawerElements[drawerID].isOpen ? "open" : "closed"}`,
          );
          if (drawerElements[drawerID].isOpen) {
            closeDrawer(drawerID);
          } else {
            openDrawer(drawerID);
          }
        } else {
          console.error(`No drawer found with id: ${drawerID}`);
        }
      }
    });

    document.addEventListener("click", function (event) {
      // Find the closest button or element with data-action="open-drawer"
      const openDrawerElement = event.target.closest(
        '[data-action="open-drawer"], button[data-action="open-drawer"]',
      );

      if (openDrawerElement) {
        console.log('data-action="open-drawer" found');
        event.preventDefault();
        openDrawer("grim-drawer");
      }
    });

    document.querySelectorAll("drawer").forEach(initializeDrawer);

    Object.defineProperties(window.drawer, {
      open: { value: openDrawer },
      close: { value: closeDrawer },
    });

    function clearCart() {
      const drawer = document.querySelector('#grim-drawer');
      drawer.classList.add('is-loading');
      
      // Add loading class to all cart items
      const cartItems = document.querySelectorAll(".grim-cart-item");
      cartItems.forEach((item) => item.classList.add("is-clearing"));

      // Wait for a short delay to allow the CSS transition to start
      setTimeout(() => {
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Cart cleared:", data);
            // Fetch the updated drawer content
            return fetch(`${window.location.pathname}?sections=grim-drawer`);
          })
          .then((response) => response.json())
          .then((sectionsData) => {
            if (sectionsData && sectionsData["grim-drawer"]) {
              updateDrawerContents(sectionsData["grim-drawer"]);
              drawer.classList.remove('is-loading');
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            drawer.classList.remove('is-loading');
          });
      }, 50); // Short delay to ensure the class is applied before the fetch request starts
    }

    // Add this to your existing event listeners
    document.addEventListener("click", function (event) {
      if (event.target.classList.contains("clear-cart")) {
        event.preventDefault();
        clearCart();
      }
    });

    // Add these new functions

    function playCentipedeVideo() {
      const centipede = document.querySelector('.cart-centipede');

      if (centipede) {
        centipede.style.opacity = '0';
        centipede.style.transition = 'opacity 1s ease-in-out';
        
        // Reset the video to start from the beginning
        centipede.currentTime = 0;
        
        // Play the video
        centipede.play().then(() => {
          setTimeout(() => {
            centipede.style.opacity = '0.1';
          }, 100);

          // Set up event listener for when the video ends
          centipede.addEventListener('ended', function onEnded() {
            centipede.style.opacity = '0';
            centipede.removeEventListener('ended', onEnded);
          }, { once: true });
        }).catch(error => {
          console.error('Error playing video:', error);
        });
      }
    }

    // Update the cart:updated event listener
    document.addEventListener('cart:updated', function(event) {
      console.log('Cart updated, opening drawer and playing video');
      openDrawer("grim-drawer", true);
      playCentipedeVideo(); // Play video every time cart is updated
    });

    console.log("Grim Drawer initialized");
  }
})();